/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerTriggerClassificationMutationRequest, TransferCustomersControllerTriggerClassificationMutationResponse } from "../../models/transferCustomersController/TransferCustomersControllerTriggerClassification";

function getTransferCustomersControllerTriggerClassificationUrl() {
  const res = { method: 'POST', url: `/api/v1/transfer-customers/classify` as const }  
  return res
}

/**
 * @summary Trigger folder/project AI classification over the transfers schema
 * {@link /api/v1/transfer-customers/classify}
 */
export async function transferCustomersControllerTriggerClassification(data?: TransferCustomersControllerTriggerClassificationMutationRequest, config: Partial<RequestConfig<TransferCustomersControllerTriggerClassificationMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransferCustomersControllerTriggerClassificationMutationResponse, ResponseErrorConfig<Error>, TransferCustomersControllerTriggerClassificationMutationRequest>({ method : "POST", url : getTransferCustomersControllerTriggerClassificationUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}